import { useOrgData } from '@frontend/get-org-data';
import { useAppFlagStore } from '@frontend/shared';

export const useWeaveAssistantSettingsFeatureFlag = () => {
  const { getFeatureFlagValue } = useAppFlagStore();
  const { locationIdsWithoutParent } = useOrgData();

  return getFeatureFlagValue({
    flagName: 'next-gen-settings',
    locationIds: locationIdsWithoutParent,
    strategy: 'ALL',
  });
};
